import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import Introduction from './components/Introduction';
import Services from './components/Services';
import Validatorinfo from './components/Validatorinfo';
import ProtectedRoute from './components/ProtectedRoute';
import LoggedInPage from './components/LoggedInPage';
import ChainDetails from './components/ChainDetails';
import AdminPanel from './components/AdminPanel';
import VisitorLogs from './components/VisitorLogs';
import VisitorTracker from './components/VisitorTracker';
import CosmosStats from './components/CosmosStats';
import SEO from './components/SEO';

import { AuthProvider } from './components/AuthContext';
import { AdminAuthProvider } from './components/AdminAuthContext';

import ForgotPassword from './components/ForgotPassword';   // 🆕 Page
import ResetPassword from './components/ResetPassword'; 
import ValServices from './components/valservices';
import './components/css/SiteContinuity.css';
              

function AppContent() {
  return (
    <div className="App">
      <SEO />
      <VisitorTracker />
      <Header />

      <div className="site-main">
      <Routes>
        <Route path="/" element={<Introduction />} />
        <Route path="/classic-dashboard" element={<Home />} />
        <Route path="/services" element={<Services />} />
          <Route path="/valservices" element={<ValServices />} />
     
        <Route path="/validatorinfo" element={
          <ProtectedRoute>
            <Validatorinfo />
          </ProtectedRoute>
        } />
        <Route path="/admin-panel" element={
          <ProtectedRoute adminOnly={true}>
            <AdminPanel />
          </ProtectedRoute>
        } />
        <Route path="/loggedin" element={
          <ProtectedRoute>
            <LoggedInPage />
          </ProtectedRoute>
        } />
        <Route path="/chain/:chainName" element={<ChainDetails />} />
        <Route path="/stats" element={<CosmosStats />} />
        <Route path="/stats/:chainKey" element={<CosmosStats />} />
        <Route path="/admin/visitor-logs" element={
          <ProtectedRoute adminOnly={true}>
            <VisitorLogs />
          </ProtectedRoute>
        } />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="*" element={<section className="site-not-found"><h1>Page not found</h1><p>Explore a network or return to the homepage.</p><Link to="/">Return home →</Link></section>} />
      </Routes>
      </div>

      <Footer />

    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AdminAuthProvider>
        <AppContent />
      </AdminAuthProvider>
    </AuthProvider>
  );
}

export default App;
